import { useState } from "react";
import { Button, Col, Form, Input, Row } from "antd";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { apiUrl } from "../../Constant";
import { routes } from "../../Routes/Routes";
import logo from "../../Assets/PNG/logo.png";
import styles from "./index.module.scss";

function ResetPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const handleSubmit = async (values) => {
    if (!token || !email) {
      toast.error("Invalid reset link. Please request a new one.");
      return;
    }

    if (values.password !== values.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(apiUrl.RESET_PASSWORD, {
        email,
        token,
        password: values.password,
      });
      if (res.data.type === "success") {
        setSuccess(true);
        toast.success("Password reset successfully");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Reset failed. The link may have expired."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token || !email) {
    return (
      <div>
        <Row justify="center" className={styles.main}>
          <Col xl={7} xxl={7} className={styles.user}>
            <div className={styles.setuser} style={{ textAlign: "center" }}>
              <img
                src={logo}
                alt="The Diamond Counter"
                style={{ width: "100%", maxWidth: 220, marginBottom: 20 }}
              />
              <p className={styles.login}>Invalid Reset Link</p>
              <p style={{ fontSize: 14, color: "#777", marginBottom: 20 }}>
                This password reset link is invalid or has expired. Please
                request a new one.
              </p>
              <Button
                className={styles.continue}
                onClick={() => navigate(routes.forgotPasswordUrl)}
              >
                Request New Link
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div>
      <Row justify="center" className={styles.main}>
        <Col xl={7} xxl={7} className={styles.user}>
          <div className={styles.setuser}>
            <img
              src={logo}
              alt="The Diamond Counter"
              style={{ width: "100%", maxWidth: 220, marginBottom: 20 }}
            />

            <p className={styles.login}>Reset Password</p>

            {success ? (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <p style={{ fontSize: 15, marginBottom: 16, lineHeight: 1.6 }}>
                  Your password has been reset successfully. You can now log in
                  with your new password.
                </p>
                <Button
                  className={styles.continue}
                  onClick={() => navigate(routes.loginUrl)}
                >
                  Go to Login
                </Button>
              </div>
            ) : (
              <Form
                form={form}
                name="reset-password"
                onFinish={handleSubmit}
                autoComplete="off"
              >
                <p style={{ fontSize: 13, color: "#777", marginBottom: 16 }}>
                  Enter your new password below.
                </p>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Password is required" },
                    {
                      min: 6,
                      message: "Password must be at least 6 characters",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="New Password"
                    className={styles.phone}
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Confirm Password"
                    className={styles.phone}
                  />
                </Form.Item>

                <Form.Item className={styles.mainbtn}>
                  <Button
                    htmlType="submit"
                    className={styles.continue}
                    loading={loading}
                  >
                    Reset Password
                  </Button>
                </Form.Item>

                <p style={{ textAlign: "center" }}>
                  <Link
                    to={routes.loginUrl}
                    style={{ color: "#C5A028", fontWeight: 600 }}
                  >
                    Back to Login
                  </Link>
                </p>
              </Form>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ResetPassword;
